<template>
    <div>
        <div :style="{height:height}" style="text-align: center ; vertical-align: center">
            <p class="my-5" style="font-size: 20px;white-space: pre-line">
                <template v-if="status == 1">
                    <img src="@/assets/loading.gif" width="40px"/>
                </template>
                <template v-if="status == 2">
                    <img src="@/assets/check.png" width="40px"/>
                </template>
                <template v-if="status == 3">
                    <img src="@/assets/not.png" width="40px"/>
                </template>
                {{msg}}
            </p>
        </div>
        <div class="col text-center" v-if="status!=1">
            <button class="btn btn-outline-secondary" type="button" style="width: 100%"
                    @click="submitData">ยืนยัน</button>
        </div>
    </div>

</template>
<script>
    export default {
         props: {
            msg: {default: ''},
            status: {default: 1},
            height: {default: 100}
        },
        name: "loading",
        methods:{
            submitData(){
                this.$emit("submit",1);
            }
        }
    }
</script>

<style scoped>
</style>
